module.exports = __webpack_public_path__ + "static/radio_p-f021566de68abcb81482766a58f691d3.png";